{
  "Net EXP includes only confirmed segments; gaps are excluded. The rate covers only the uninterrupted segment after recovery.": "순 경험치는 확인된 구간만 합산하며 누락 구간은 제외합니다. 효율은 복구 후 연속 구간만으로 계산합니다.",
  "Net EXP includes only confirmed segments; gaps are excluded. The average uses confirmed segment duration.": "순 경험치는 확인된 구간만 합산하며 누락 구간은 제외합니다. 평균 효율은 확인된 구간의 시간으로 계산합니다.",
  "First session gap": "기록의 첫 누락 구간",
  "Ready": "레벨업 가능",
  "{p0}m": "{p0}분",
  "{p0}h {p1}m": "{p0}시간 {p1}분",
  "{p0}d {p1}h": "{p0}일 {p1}시간",
  "Map unconfirmed": "지도 미확인",
  "Map pending confirmation": "지도 확인 대기 중",
  "Waiting for map recognition": "맵 인식 대기",
  "Recognizing map": "지도를 인식하는 중",
  "Finishing": "종료 중",
  "Confirming": "확인 중",
  "Net EXP": "순 경험치",
  "Gained": "획득",
  "4h 57m": "4시간 57분",
  "8h 51m": "8시간 51분",
  "Victoria Island / Forest of Wisdom": "빅토리아 아일랜드 / 지혜의 숲",
  "Maple Log": "Maple Log",
  "Widget": "위젯",
  "Loading widget…": "위젯 로드 중…",
  "Your panel will appear when ready": "준비되면 패널이 나타납니다.",
  "": "",
  "Waiting for readings": "인식값 대기 중",
  "Gathering samples": "샘플 수집",
  "No rate available": "효율 데이터 없음",
  "Since recovery": "복구 후 효율",
  "Confirming an EXP change.": "경험치 변경을 확인하는 중입니다.",
  "Waiting for a fresh level reading.": "새로운 수준의 인식값을 기다리고 있습니다.",
  "Cross-level EXP evidence is missing.": "교차 레벨 경험치 증거가 누락되었습니다.",
  "Waiting for a readable game frame.": "읽을 수 있는 게임 화면을 기다리고 있습니다.",
  "The EXP change could not be confirmed in time.": "경험치 변경 사항을 제때 확인할 수 없었습니다.",
  "Capture continuity was interrupted during confirmation.": "확인 중에 캡처 연속성이 중단되었습니다.",
  "EXP / hour": "경험치 / 시간",
  "Waiting for complete EXP evidence.": "완전한 경험치 증거를 기다리고 있습니다.",
  "Some EXP readings could not be confirmed, so session net EXP is unavailable. The rate covers only the uninterrupted segment after recovery.": "일부 경험치 판독값을 확인할 수 없으므로 세션 네트 경험치를 사용할 수 없습니다. 이 요금은 복구 후 중단되지 않는 세그먼트에만 적용됩니다.",
  "Recovery baseline": "복구 시작점",
  "Last confirmed": "마지막 확인",
  "EXP/h": "경험치/시간",
  "Showing the last confirmed values while checking.": "확인하는 동안 마지막으로 확인된 값을 표시합니다.",
  "The last reading is too old to show as a current rate.": "마지막 판독값이 너무 오래되어 현재 속도로 표시할 수 없습니다.",
  "Last 60s: {p0} EXP/h\nSession average: {p1} EXP/h\nDifference: {p2} EXP/h\nLast sample: {p3}\nArrows appear at 4% and hide 1.5s after returning to 2%, with recognition-delay protection. Window edges and cross-level gains may be estimated.": "지난 60초: {p0} 경험치/h\n세션 평균: {p1} 경험치/h\n차이: {p2} 경험치/h\n마지막 샘플: {p3}\n화살표는 4%에서 나타나고 인식 지연 보호 기능을 통해 2%로 돌아온 후 1.5초 동안 숨겨집니다. 창 가장자리와 교차 수준 이득이 추정될 수 있습니다.",
  "Elapsed": "경과됨",
  "EXP / h": "경험치 / 시간",
  "Mesos / h": "메소 / 시간",
  "Map": "맵",
  "Recognizing": "인식",
  "Start": "시작",
  "Pause": "일시중지",
  "Resume": "이력서",
  "End": "종료",
  "Confirming EXP": "경험치 확인 중",
  "HP": "HP",
  "MP": "국회의원",
  "Lv.": "레벨",
  "Level up": "레벨업까지",
  "Full level": "한 레벨 소요 시간",
  "Change": "변경",
  "Net": "순 증가",
  "Live metrics": "실시간 통계",
  "Idle": "대기 중",
  "Recording": "기록 중",
  "Paused": "일시 중지",
  "Ended": "종료됨",
  "Interrupted": "중단됨",
  "{p0}h": "{p0}시간",
  "EXP reading details": "경험치 인식 설명",
  "Close": "닫기",
  "Loading preview…": "미리보기 로드 중…",
  "Widget layout preview": "위젯 레이아웃 미리보기",
  "Start balance": "시작 메소",
  "Display unavailable. Reopen the widget.": "표시 오류입니다. 위젯을 다시 열어 주세요.",
  "Reading details when opened": "열었을 때의 읽기 정보",
  "Waiting to start": "기록 시작 대기",
  "Waiting for valid data": "유효한 데이터 대기 중",
  "No chart data": "그래프 데이터 없음",
  "Waiting for a sample point": "표본 지점 대기 중",
  "{seconds}/{window}s": "{seconds}/{window}초",
  "Waiting for character": "캐릭터 인식 대기"
}
